export default __webpack_public_path__ + "7e3ac9afb25cfe8095201eddd0b6629a.svg";